import React, { useEffect } from "react";
import { List } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import EditIcon from "@material-ui/icons/Edit";
import { withRouter } from "react-router";
import { get } from "../../api/axios";

const PublicidadList = props => {
  const [publicidades, setPublicidades] = React.useState([]);
  useEffect(() => {
    get("/publicidades").then(response => {
      let publicidades = response.data.sort(function (a, b) {
        if (a.nombre < b.nombre) { return -1; }
        if (a.nombre > b.nombre) { return 1; }
        return 0;
      });
      setPublicidades(publicidades);
    });

  }, []);

  return (
    <List
      component="nav"
      aria-label="main mailbox folders"
      style={{ maxHeight: "400px", overflow: "auto" }}
    >
      {publicidades.map((publicidad, key) => {
        return (
          <ListItem
            button
            onClick={() => props.history.push("/publicidad/editar/" + publicidad.id)}
            key={key}
          >
            <ListItemText primary={publicidad.titulo} />
            <ListItemIcon>
              <EditIcon />
            </ListItemIcon>
          </ListItem>
        );
      })}
    </List>
  );
};

export default withRouter(PublicidadList);
